import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

/**
 * Functional HTTP interceptor that handles 401 authentication errors.
 * On a 401 response, logs a message indicating the session has expired.
 * The actual redirect to origin is handled by HttpService.errorCustomHandler
 * for non-token endpoints.
 */
export const authenticatedInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        console.log('The authentication session expires or the user is not authorised. Force refresh of the current page.');
      }
      return throwError(() => error);
    })
  );
};
